/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useRef, useState } from "react";
import { Form, SelectPicker } from "rsuite";
import { useAppDispatch } from "../../core/redux/ReduxStore";
import { appointmentCalendarActions } from "../../core/redux/slices/sliceAppointmentCalendar";
import { Button } from "../../components/button.component";
import { ApiPatient, ApiCaregiver } from "../../core/apis";
import { StorageAuth } from "../../core/localStorage";

const initialValue = { caregiver: "", patient: "" };

export const DashboardFilter = () => {
  const [formValue, setFormValue] = useState(initialValue);
  const patientTimeoutId = useRef<number>();
  const nurseTimeoutId = useRef<number>();
  const dispatch = useAppDispatch();
  const selectedCompany = StorageAuth.CompanyId || "";

  // Get patients and caregivers data
  const { data: patients } = ApiPatient.GetAllFromCompany.Hook(selectedCompany);
  const { data: caregivers } =
    ApiCaregiver.GetAllFromCompany.Hook(selectedCompany);

  // Transform patient and caregiver data for SelectPicker
  const patientsSelectItems =
    patients?.map((patient) => ({
      label: `${patient.firstName} ${patient.lastName}`,
      value: patient.firstName,
    })) || [];

  const caregiversSelectItems =
    caregivers?.map((caregiver) => ({
      label: `${caregiver.firstName} ${caregiver.lastName}`,
      value: caregiver.firstName,
    })) || [];

  const resetForm = () => {
    setFormValue(initialValue);
    dispatch(appointmentCalendarActions.setIsLoading(true));
    dispatch(appointmentCalendarActions.setFilterPatient(""));
    dispatch(appointmentCalendarActions.setFilterNurse(""));
  };

  const filterPatient = useCallback((patient: string): void => {
    setFormValue((prev) => ({ ...prev, patient: patient }));
    dispatch(appointmentCalendarActions.setIsLoading(true));
    clearTimeout(patientTimeoutId.current);
    patientTimeoutId.current = setTimeout(
      () => dispatch(appointmentCalendarActions.setFilterPatient(patient)),
      500
    ) as unknown as number;
  }, []);

  const filterNurse = useCallback((nurse: string): void => {
    setFormValue((prev) => ({ ...prev, caregiver: nurse }));
    dispatch(appointmentCalendarActions.setIsLoading(true));
    clearTimeout(nurseTimeoutId.current);
    nurseTimeoutId.current = setTimeout(
      () => dispatch(appointmentCalendarActions.setFilterNurse(nurse)),
      500
    ) as unknown as number;
  }, []);

  return (
    <Form className="row" fluid formValue={formValue}>
      <Form.Group className="col-md-5 col-12">
        <Form.ControlLabel>Filter By Caregiver:</Form.ControlLabel>
        <SelectPicker
          data={caregiversSelectItems}
          value={formValue.caregiver}
          onChange={(value) => filterNurse(value as string)}
          cleanable
          searchable
          style={{ width: "100%" }}
          placeholder="Select a caregiver"
        />
      </Form.Group>
      <Form.Group className="col-md-5 col-12">
        <Form.ControlLabel>Filter By Patient:</Form.ControlLabel>
        <SelectPicker
          data={patientsSelectItems}
          value={formValue.patient}
          onChange={(value) => filterPatient(value as string)}
          cleanable
          searchable
          style={{ width: "100%" }}
          placeholder="Select a patient"
        />
      </Form.Group>
      <div className="col-md-2 col-12 d-flex justify-content-center align-items-center">
        <Button name="Reset" className="btn-green w-100" onClick={resetForm} />
      </div>
    </Form>
  );
};
